import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TGetFeedsQuery } from '../helpers/types';
import { getFeeds, deleteFeed, getFeed, updateFeed, createFeed, regenerateFeed } from './actionCreators';
import { initialState, FEEDS_SLICE_NAME, FeedsListState } from './models';

export const slice = createSlice({
  name: FEEDS_SLICE_NAME,
  initialState,
  reducers: {
    resetFeedsState() {
      return initialState;
    },
    changeQuery: (state: FeedsListState, action: PayloadAction<TGetFeedsQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeeds.fulfilled, (state: FeedsListState, action) => {
        state.feedsList = action.payload;
        state.isLoading = false;
      })
      .addMatcher(isFulfilled(createFeed, deleteFeed, getFeed, updateFeed, regenerateFeed), (state: FeedsListState) => {
        state.isLoading = false;
      })
      .addMatcher(
        isPending(createFeed, deleteFeed, getFeed, getFeeds, updateFeed, regenerateFeed),
        (state: FeedsListState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(createFeed, deleteFeed, getFeed, getFeeds, updateFeed, regenerateFeed),
        (state: FeedsListState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetFeedsState, changeQuery } = slice.actions;

export default slice.reducer;
